import { useState } from 'react'
import { Settings, Save, Server, Shield, Bell } from 'lucide-react'
import { Button, Input } from '../../components/ui'

export const PlatformSettings = () => {
    const [maintenance, setMaintenance] = useState(false)
    const [registrations, setRegistrations] = useState(true)
    const [emailNotifs, setEmailNotifs] = useState(true)
    const [systemAlerts, setSystemAlerts] = useState(true)

    return (
        <div className="p-8 max-w-5xl mx-auto bg-gray-50 min-h-screen pb-20">
            <div className="flex justify-between items-start mb-8">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                        <Settings className="text-green-600" />
                        Globale Instellingen
                    </h1>
                    <p className="text-gray-500">Systeem-brede configuratie en beveiligingsinstellingen</p>
                </div>
                <div className="flex items-center gap-2 bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-bold">
                    👑 Super Admin Only
                </div>
            </div>

            <div className="space-y-6">
                {/* System Control */}
                <Section title="Systeem Controle" icon={Server}>
                    <Toggle
                        label="Onderhoudsmodus"
                        desc="Blokkeert toegang voor alle gebruikers behalve super admins"
                        checked={maintenance}
                        onChange={setMaintenance}
                    />
                    <Toggle
                        label="Nieuwe Registraties"
                        desc="Sta nieuwe gebruikers toe om accounts aan te maken"
                        checked={registrations}
                        onChange={setRegistrations}
                    />
                </Section>

                {/* Limits */}
                <Section title="Gebruikerslimieten" icon={Shield}>
                    <p className="text-sm text-gray-500 mb-6">Beperkingen om systeemprestaties te waarborgen</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <Input label="Max Gebruikers per Toernooi" defaultValue="500" />
                        <Input label="Max Toernooien per Gebruiker" defaultValue="10" />
                        <Input label="Sessie Timeout (uren)" defaultValue="24" />
                        <Input label="API Rate Limit (per uur)" defaultValue="1000" />
                    </div>
                </Section>

                {/* Notifications */}
                <Section title="Notificatie Instellingen" icon={Bell}>
                    <Toggle
                        label="E-mail Notificaties"
                        desc="Verstuur automatische e-mails voor belangrijke events"
                        checked={emailNotifs}
                        onChange={setEmailNotifs}
                    />
                    <Toggle
                        label="Systeem Alerts"
                        desc="Ontvang meldingen bij kritieke systeem events"
                        checked={systemAlerts}
                        onChange={setSystemAlerts}
                    />
                </Section>

                {/* Save Bar */}
                <div className="flex justify-end pt-4">
                    <Button className="bg-orange-500 hover:bg-orange-600 shadow-lg shadow-orange-500/20">
                        <Save size={18} className="mr-2" />
                        Instellingen Opslaan
                    </Button>
                </div>
            </div>
        </div>
    )
}

const Section = ({ title, icon: Icon, children }) => (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
            <div className="bg-gray-100 p-2 rounded-lg text-gray-600">
                <Icon size={20} />
            </div>
            <h3 className="text-lg font-bold text-gray-900">{title}</h3>
        </div>
        {children}
    </div>
)

const Toggle = ({ label, desc, checked, onChange }) => (
    <div className="flex items-center justify-between py-4 border-b border-gray-50 last:border-0 last:pb-0">
        <div>
            <h4 className="font-bold text-gray-900">{label}</h4>
            <p className="text-sm text-gray-500">{desc}</p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                className="sr-only peer"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
            />
            <div className={`
                w-11 h-6 rounded-full peer 
                peer-focus:outline-none 
                peer-checked:after:translate-x-full peer-checked:after:border-white 
                after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
                after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                ${checked ? 'bg-purple-600' : 'bg-gray-200'}
            `}></div>
        </label>
    </div>
)
